<div class="row">
  <div
    class="col-md-12 our-packages-header d-flex justify-content-center align-items-center"
  >
    <p class="text-center text-white fs-1 fw-bold">
      {{ "Websites" | translate }}
    </p>
  </div>
  <div class="col-12" *ngFor="let section of sections">
    <div class="row">
      <div
        class="col-12 align-items-center d-flex justify-content-center mb-lg-5 mb-4 pb-3 title text-center position-relative mt-5"
      >
        <h3 class="mb-0 fw-bold fs-3 position-relative ">
          {{ section.title | translate }}
        </h3>
        <div class="bg-highlight position-absolute"></div>
      </div>
      <div class="row px-5 m-0">
        <div class="col-md-6 p-3" *ngFor="let project of section.projects">
          <div class="row border rounded-3 w-100 m-0 p-4">
            <div class="col-12 d-flex justify-content-center">
              <img class="w-75" [src]="project.imgSrc" alt="" />
            </div>
            <div class="col-12 d-flex justify-content-center mt-2">
              <a
                [href]="project.link"
                target="_blank"
                class="text-decoration-none text-black fs-3 fw-bold text-break text-center w-100"
                >{{ project.link }}</a
              >
            </div>
            <div class="col-12 d-flex justify-content-center gap-2 mt-3">
              <a [href]="project.appStoreLink" target="_blank">
                <img
                  src="../../../assets/images/app-store.png"
                  alt=""
                  width="100"
                />
              </a>
              <a [href]="project.googlePlayLink" target="_blank">
                <img
                  src="../../../assets/images/google-play.png"
                  alt=""
                  width="100"
                />
              </a>
            </div>
            <div class="col-12 d-flex justify-content-center mt-4">
              <a
                class="btn btn-gold fs-4 px-5 fw-bold text-decoration-none"
                [routerLink]="'/ourPackages/details/' + project.name"
              >
                {{ "More" | translate }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
